import { type ProjectConfigurationAttributes } from './generated/ProjectConfigurationAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import { JsonQuerySerialization } from './concerns/JsonQuerySerialization';

interface ProjectConfiguration extends ProjectConfigurationAttributes {}

@model
@JsonQuerySerialization
class ProjectConfiguration extends ApplicationModel {
  // Start auto-generated
  static typename: 'ProjectConfiguration' = 'ProjectConfiguration';
  get typename(): 'ProjectConfiguration' {
    return 'ProjectConfiguration';
  }

  static internalTypename: 'ProjectConfiguration' = 'ProjectConfiguration';
  get internalTypename(): 'ProjectConfiguration' {
    return 'ProjectConfiguration';
  }

  static inputType = 'ProjectConfigurationAttributes';

  static fields = {
    createdAt: attr({ readable: true }),
    epicsEnabled: attr({ readable: true }),
    reviewerDocumentAccess: attr({ readable: true }),
    sprintPlanningEstimates: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    cardLayout: attr.belongsTo({
      writeShape: [
        'epicRecordLayout',
        'featureRecordLayout',
        'ideaRecordLayout',
        'initiativeRecordLayout',
        'releaseRecordLayout',
        'releasePhaseRecordLayout',
        'requirementRecordLayout',
        'taskRecordLayout',
        'goalRecordLayout',
        'keyResultRecordLayout',
      ],
      readable: true,
      typename: 'CardLayout',
    }),
    defaultCardLayout: attr.belongsTo({
      readable: true,
      typename: 'CardLayout',
    }),
    projectRisksConfiguration: attr.belongsTo({
      readable: true,
      typename: 'ProjectRisksConfiguration',
    }),
    projectScreens: attr.belongsTo({
      readable: true,
      typename: 'ProjectScreens',
    }),
  };
  // End auto-generated
}

export default ProjectConfiguration;
